// model-viewer 4.x draws a focus ring around its inner `.userInput` element
// once the viewer has focus and a key has been pressed (:focus-visible), e.g.
// after tapping f / r. Production never showed one (BZL-212). The ring lives
// inside the shadow DOM, so no page stylesheet reaches it: add the rule there.
const RULE = '.userInput:focus,.userInput:focus-visible{outline:none}';

export function quietFocusRing(mv) {
  if (!mv || typeof window === 'undefined' || !window.customElements) return;
  window.customElements.whenDefined('model-viewer').then(() => {
    const root = mv.shadowRoot;
    if (!root || root.querySelector('style[data-og-quiet-focus]')) return;
    const style = document.createElement('style');
    style.setAttribute('data-og-quiet-focus', '');
    style.textContent = RULE;
    root.appendChild(style);
  });
}
